
export default {
  props: {
    theme: {
      type: String,
      default: 'dark',
    },
  },
}
